import React, { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

// Composant bouton magnétique XXL
const MagneticContactButton = ({ children, href, target, rel, color, glowColor }) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const springX = useSpring(x, { damping: 15, stiffness: 150 });
  const springY = useSpring(y, { damping: 15, stiffness: 150 });

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    x.set((e.clientX - centerX) * 0.15);
    y.set((e.clientY - centerY) * 0.15);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.a
      ref={ref}
      href={href}
      target={target}
      rel={rel}
      className="contact-btn-xxl"
      style={{
        x: springX,
        y: springY,
        "--glow-color": glowColor,
        "--text-color": color
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {children}
    </motion.a>
  );
};

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.5 }}
      >
        Me contacter
      </motion.h2>

      <motion.div
        className="contact-card"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <p className="contact-text">
          Je suis disponible pour échanger autour d'opportunités, de projets ou de collaborations.
        </p>

        <div className="contact-buttons">
          <MagneticContactButton
            href="mailto:elisa.gomez.dev@gmail.com"
            color="#efa206"
            glowColor="rgba(239, 162, 6, 0.4)"
          >
            <div className="btn-icon">
              <FaEnvelope />
            </div>
            <div className="btn-content">
              <span className="btn-label">Email</span>
              <span className="btn-detail">elisa.gomez.dev@gmail.com</span>
            </div>
          </MagneticContactButton>

          <MagneticContactButton
            href="https://www.linkedin.com/in/elisa-gomez-100a7033b/"
            target="_blank"
            rel="noopener noreferrer"
            color="#0077B5"
            glowColor="rgba(0, 119, 181, 0.4)"
          >
            <div className="btn-icon">
              <FaLinkedin />
            </div>
            <div className="btn-content">
              <span className="btn-label">LinkedIn</span>
              <span className="btn-detail">Voir mon profil</span>
            </div>
          </MagneticContactButton>

          <MagneticContactButton
            href="https://github.com/ElysaG"
            target="_blank"
            rel="noopener noreferrer"
            color="#ffffff"
            glowColor="rgba(255, 255, 255, 0.4)"
          >
            <div className="btn-icon">
              <FaGithub />
            </div>
            <div className="btn-content">
              <span className="btn-label">GitHub</span>
              <span className="btn-detail">Voir mes projets</span>
            </div>
          </MagneticContactButton>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;